import { JupiterTheme } from '../theme/types';

const aceEditorStyles = (theme: JupiterTheme) => ({
  '& .ace_gutter': {
    color: theme.palette.grey[800],
  },
  '& .ace_fold': {
    backgroundColor: theme.palette.navy[400],
  },
  '& .ace-tm': {
    color: theme.palette.grey[800],
  },
  '& .ace_cursor': {
    color: theme.palette.primary.dark,
  },
  '& .ace_storage, & .ace_keyword': {
    color: theme.palette.primary.dark,
  },
  '& .ace_constant': {
    color: theme.palette.red[600],
  },
  '& .ace_constant.ace_buildin': {
    color: theme.palette.navy[500],
  },
  '& .ace_constant.ace_language': {
    color: theme.palette.navy[400],
  },
  '& .ace_constant.ace_library': {
    color: theme.palette.green[800],
  },
  '& .ace_invalid': {
    backgroundColor: theme.palette.red[50],
    color: theme.palette.red[500],
  },
  '& .ace_support.ace_function': {
    color: theme.palette.navy[600],
  },
  '& .ace_support.ace_constant': {
    color: theme.palette.green[800],
  },
  '& .ace_support.ace_type, & .ace_support.ace_class': {
    color: theme.palette.navy[400],
  },
  '& .ace_keyword.ace_operator': {
    color: theme.palette.navy[300],
  },
  '& .ace_string': {
    color: theme.palette.green[900],
  },
  '& .ace_comment': {
    color: theme.palette.green[800],
  },
  '& .ace_comment.ace_doc': {
    color: theme.palette.primary.main,
  },
  '& .ace_comment.ace_doc.ace_tag': {
    color: theme.palette.navy[200],
  },
  '& .ace_constant.ace_numeric': {
    color: theme.palette.primary.dark,
  },
  '& .ace_variable': {
    color: theme.palette.primary.dark,
  },
  '& .ace_xml-pe': {
    color: theme.palette.coolGrey[600],
  },
  '& .ace_entity.ace_name.ace_function': {
    color: theme.palette.primary.dark,
  },
  '& .ace_heading': {
    color: theme.palette.primary.dark,
  },
  '& .ace_list': {
    color: theme.palette.red[400],
  },
  '& .ace_meta.ace_tag': {
    color: theme.palette.navy[600],
  },
  '& .ace_string.ace_regex': {
    color: theme.palette.red[500],
  },
  '& .ace_marker-layer .ace_selection': {
    background: theme.palette.blue[50],
  },
  '& .ace_marker-layer .ace_step': {
    background: theme.palette.yellow[400],
  },
  '& .ace_marker-layer .ace_stack': {
    background: theme.palette.green[100],
  },
  '& .ace_marker-layer .ace_selected-word': {
    background: theme.palette.coolGrey[200],
    border: '1px solid ' + theme.palette.navy[100],
  },
});

export default aceEditorStyles;
